﻿import React from 'react';
import { connect } from 'react-redux';
import { VeilederBsAppState } from '../Store';
import { toggleAvstand } from '../Store/Valg/Actions';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import * as ValgTypes from '../Store/Valg/Types';

interface ModalKlikkPropsOwnProps {
    valg: ValgTypes.ValgState;
    lenketekst: JSX.Element | null;
    overskrift: JSX.Element | null;
    content: JSX.Element | null;
    ariaLabel: string;
    eventId: string | null;
}

type ModalKlikkProps = MapStateToProps & MapDispatchToProps & ModalKlikkPropsOwnProps;

class ModalKlikkComponent extends React.PureComponent<ModalKlikkProps> {
    constructor(props: ModalKlikkProps) {
        super(props);
        this.onAvstandClick = this.onAvstandClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleAvstand();
    }

    onAvstandClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleAvstand();
    }

    render(): JSX.Element {
        const { visAvstand, lenketekst, overskrift, content, ariaLabel, eventId } = this.props;

        return (
            <div className="c-veileder__panel-row c-veileder__content-custom">
                <div className="c-veileder__content c-veileder__content--linkarea">
                    <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onAvstandClick}>
                        {lenketekst}
                    </button>
                    <ModalCompontent isOpen={visAvstand} onRequestClose={this.onRequestClose} ariaCloseText={ariaLabel} eventId={eventId}>
                        <ArticleContentComponent headerinnhold={overskrift} contentinnhold={content} />
                    </ModalCompontent>
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    visAvstand: boolean;
}

interface MapDispatchToProps {
    toggleAvstand: typeof toggleAvstand;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederBsAppState): MapStateToProps => {
        return {
            visAvstand: state.valg.visAvstand,
        };
    },
    { toggleAvstand, updateZIndex },
)(ModalKlikkComponent);
